import React, { useEffect } from "react";
import { Form, Spin, Button } from "antd";
import RenderFilterFields from "./RenderFilterFields";

const QuestionsFilter = ({
  savedFormValues = () => {},
  handleClear = () => {},
  handleFinish = () => {},
  filterData = [],
  filterDataLoading = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(savedFormValues);
  }, [savedFormValues]);

  const handleFieldChange = (fieldCode, value) => {
    form.setFieldsValue({ [fieldCode]: value });
  };
  const onSubmit = (values) => handleFinish(values, form);
  return (
    <>
      <Spin spinning={filterDataLoading}>
        <Form layout="vertical" onFinish={onSubmit} form={form}>
          <RenderFilterFields
            filtersData={filterData.filters || []}
            onFieldChange={handleFieldChange}
          />
          {filterData.filters && filterData.filters.length > 0 && (
            <div className="d-flex justify-content-between mt-3">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Button onClick={handleClear}>Clear</Button>
            </div>
          )}
        </Form>
      </Spin>
    </>
  );
};

export default QuestionsFilter;
